<div class="numeric-textbox-container" [ngClass]="{ 'has-errors': hasErrors }">
  <boi-validation-error-generic
    (errorChange)="onErrorChange($event)"
    [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames"
  >
  </boi-validation-error-generic>
  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined">
        <div class="label-content">
          <label
            [innerHtml]="shouldNotLocalize ? labelName : (labelName | localizeLabel)"
            [for]="controlId ? controlId : labelName"
          >
          </label>
        </div>
        <boi-tooltip *ngIf="showTooltip && !isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
        </boi-tooltip>
      </div>

      <div class="field-input">
        <kendo-numerictextbox
          [ngClass]="{ currency: isCurrency }"
          [id]="controlId ? controlId : labelName"
          [(ngModel)]="value"
          [min]="min"
          [max]="max"
          [format]="getFormat()"
          [decimals]="decimals"
          (blur)="onBlur()"
          [autoCorrect]="autoCorrect"
          (keypress)="checkInputLength($event)"
          [disabled]="isFieldDisabled"
          [spinners]="false"
          [step]="0"
          [required]="required"
          #numericInput
          [boiDisableNumericInputIncrementation]="true"
        >
        </kendo-numerictextbox>
        <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
        </boi-tooltip>
      </div>
    </div>
  </kendo-textbox-container>
</div>
